<template>
	<div class="animated fadeIn">
		<b-card>
			<div class="display-table full-width mb-5">
				<strong class="card-title">{{$route.meta.label}}</strong>
				<b-button class="btn btn-primary display-table-cell pull-right text-white rounded" v-b-modal.add-news>
					<i class="fa fa-plus"/> Add News
				</b-button>
			</div>
			<b-row class="justify-content-between mb-10">
				<ResponseAlert ref="response" />
				<b-col sm="5">
					<b-button-group>
						<b-button
							v-for="type, index in masters.types"
							:key="index"
							class="border-0"
							:variant="type.value === config.additional_params.type ? 'primary' : 'link'" v-text="type.text"
							v-model="config.additional_params.type"
							@click="config.additional_params.type = type.value"
							/>
					</b-button-group>
				</b-col>
				<b-col sm="5">
					<b-form-select class="col-sm-4" v-model="config.additional_params.category_id" :options="masters.categories"></b-form-select>
					<div class="col-sm-7 pull-right no-padding">
						<div class="input-group">
							<input type="text" placeholder="Search title" v-model="config.search.key" v-on:keyup.enter="get()"
								class="form-control form-control-sm" />
							<div class="input-group-prepend">
								<div class="input-group-text" v-on:click="get()">
									<i class="fa fa-search"></i>
								</div>
							</div>
						</div>
					</div>
				</b-col>
			</b-row>
			<b-row>
				<b-col sm="12">
					<div class="table-responsive">
						<table class="table b-table">
							<thead>
								<tr>
									<th v-for="(row, key) in config.headers" :width="row.width" :key="key"
										:class="row.class">
										<a v-if="row.value" class="sort dark-font" v-on:click="sort(row.value)"
											href="javascript:void(0)">
											{{row.title}}
											<i :id="row.value" class="fa fa-sort"></i>
										</a>
										<a v-else class="sort dark-font" :id="row.value" href="javascript:void(0)">
											{{row.title}}
										</a>
									</th>
								</tr>
							</thead>
							<tbody>
								<template v-if="config.total_data">
									<tr v-for="(row, key) in config.rows" :key="key">
										<td>{{row.title}}</td>
										<td>{{vars.moment(row.date).format('DD MMM YYYY HH:mm')}}</td>
										<td>{{row.category && row.category.name}}</td>
										<td>{{row.total_read}}</td>
										<td>
											<span :class="'badge badge-' + getClassStatus(row.status)">
												{{row.status}}
											</span>
										</td>
										<td align="center">
											<!-- <router-link :to='`/${config.uri}/${row.id}`' title="Detail"
												class="btn-action">
												<i class="fa fa-eye"></i>
											</router-link>
											<router-link :to='`/${config.uri}/edit/${row.type}/${row.id}`' title="Edit"
												class="btn-action">
												<i class="fa fa-pencil"></i>
											</router-link> -->
											<button @click="goToDetail(row.id)" title="Detail" class="btn-action">
												<i class="fa fa-eye"></i>
											</button>
											<button @click="goToEdit(row.type, row.id)" title="Edit" class="btn-action">
												<i class="fa fa-pencil"></i>
											</button>
											<button @click="destroy(row.id)" title="Delete" class="btn-action">
												<i class="fa fa-trash"></i>
											</button>
										</td>
									</tr>
								</template>
								<tr v-if="!config.total_data">
									<td :colspan="config.headers.length" align="center"> No data available. </td>
								</tr>
							</tbody>
							<tfoot v-if="config.total_data">
								<tr>
									<td :colspan="config.headers.length" class="no-padding">
										<div class="pull-left table-information mt-25">
											<p>Showing {{config.page}} to {{config.total_page}} of {{config.total_data}}
												entries</p>
										</div>
										<div class="pull-right pagination mt-25">
											<b-pagination @change="gotoPage" :total-rows="config.total_data"
												v-model="config.page" :per-page="config.per_page">
											</b-pagination>
										</div>
									</td>
								</tr>
							</tfoot>
						</table>
					</div>
				</b-col>
			</b-row>
		</b-card>

		<!-- The modal -->
		<b-modal centered id="add-news" hide-footer title="Type of news">
			<b-row class="my-4">
				<b-col class="text-center">
					<!-- <router-link :to="'/'+config.uri+'/article/add'"
						class="btn btn-primary rounded px-4">
							Article
					</router-link>
					<router-link :to="'/'+config.uri+'/photo/add'"
						class="btn btn-primary rounded px-4">
							Photo
					</router-link>
					<router-link :to="'/'+config.uri+'/video/add'"
						class="btn btn-primary rounded px-4">
							Video
					</router-link> -->
					<button class="btn btn-primary rounded px-4" @click="goTo('article')">
						Article
					</button>
					<button class="btn btn-primary rounded px-4" @click="goTo('photo')">
						Photo
					</button>
					<button class="btn btn-primary rounded px-4" @click="goTo('video')">
						Video
					</button>
				</b-col>
			</b-row>
		</b-modal>
	</div>
</template>
<script>
	import moment from 'moment'
	import table from '@/utils/table.js'
	import api from '@/utils/api.js'
	import ResponseAlert from '@/components/response_alert';
	import { getClassStatus } from '@/utils/helpers';
	export default {
		name: 'ListNews',
		components: {
			ResponseAlert,
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
					api: api.news,
					rows: [],
					total_data: 0,
					total_page: 0,
					per_page: 10,
					page: 1,
					orderby: "id",
					sort: "desc",
					search: {
						key: ""
					},
					additional_params: {
						is_contributor_news: false,
						type: '',
						category_id: ''
					},
					headers: [{
						title: "Title",
						value: "title",
						align: "text-left",
						width: "25%",
					}, {
						title: "Date",
						value: "date",
						align: "text-left",
						width: "15%",
					}, {
						title: "Category",
						value: "category_id",
						align: "text-left",
						width: "15%",
					}, {
						title: "View",
						value: false,
						align: "text-left",
						width: "15%",
					}, {
						title: "Status",
						value: "status",
						align: "text-left",
						width: "15%",
					}, {
						title: "Action",
						value: false,
						class: "text-center",
						width: "15%",
					}],
				},
				vars: {
					moment
				},
				masters: {
					types: [
						{
							value: '',
							text: 'All'
						},
						{
							value: 'article',
							text: 'Article'
						},
						{
							value: 'photo',
							text: 'Photo'
						},
						{
							value: 'video',
							text: 'Video'
						},
					],
					categories: [
						{
							value: '',
							text: 'Category'
						}
					]
				},
			}
		},
		created() {
			const _ = this;

			// Check if there’s saved state
			const saved = localStorage.getItem('news_list_state');
			if (saved) {
				const state = JSON.parse(saved);
				_.config.page = state.page || 1;
				_.config.per_page = state.per_page || 10;
				_.config.search.key = state.search || "";
				_.config.additional_params.type = state.type || '';
				_.config.additional_params.category_id = state.category_id || '';
				localStorage.removeItem('news_list_state');
			}

			_.get();
			_.getCategory()
		},
		methods: {
			get() {
				table.get(this.config)
			},
			sort(orderby) {
				table.sort(this.config, orderby)
			},
			gotoPage(page) {
				table.gotoPage(this.config, page)
			},
			getClassStatus(status) {
				return getClassStatus(status);
			},
			destroy(id) {
				const _ = this;
				_.$dialog.confirm('Are you sure want to delete this data?', {
						"okText": "Yes",
						"cancelText": "No"
					})
					.then(() => {
						_.$axios.delete(`${api.news}/${id}`)
						.then(res => {
							_.$refs.response.setResponse(res.data.message, 'success');
							_.get()
						}).catch(error => {
							_.$refs.response.setResponse(error.response.data.message, 'danger')
						})
					})
			},
			getCategory() {
				const _ = this
				_.$axios.get(api.news_category, {
					params: {
						status: 'active',
						orderby: 'name',
						sort: 'asc',
					}
				}).then(res => {
						const categories = res.data.data.rows
						categories.forEach(category => {
							_.masters.categories.push({
								value: category.id,
								text: category.name
							})
						})
					}
				);
			},
			goTo(type) {
				this.saveListState();
				this.$router.push(`/${this.config.uri}/${type}/add`);
			},
			goToDetail(id) {
				this.saveListState();
				this.$router.push(`/${this.config.uri}/${id}`);
			},
			goToEdit(type, id) {
				this.saveListState();
				this.$router.push(`/${this.config.uri}/edit/${type}/${id}`);
			},
			saveListState() {
				localStorage.setItem('news_list_state', JSON.stringify({
					page: this.config.page,
					per_page: this.config.per_page,
					search: this.config.search.key,
					type: this.config.additional_params.type,
					category_id: this.config.additional_params.category_id
				}));
			},
		},
		computed: {
			filter_change() {
				return `${this.config.additional_params.type}${this.config.additional_params.category_id}`
			}
		},
		watch: {
			filter_change() {
				const _ = this
				_.get()
			},
		}
	}
</script>
